
import { createApiClient } from 'Network/ApiClient';

export const DrugCustomGroupAxiosInstance = createApiClient('Drugscustom/');


